export default __webpack_public_path__ + "static/media/3.a3be2bc1.jpg";